import { CreateGMWTask, EditGMWTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import { electrodeSchema } from "./gmw-electrode-schema";

/**
 * Schema for Geo-ohm cable within a monitoring tube
 */
export const geoOhmCableSchema = {
  type: "array",
  title: "Geo-Ohm kabels",
  minItems: 0,
  maxItems: 10,
  items: {
    type: "object",
    title: "Geo-Ohm kabel",
    required: ["cableNumber"],
    properties: {
      ...pickGmwLibraryFields(["cableNumber"]),
      electrodes: electrodeSchema,
    },
  },
} satisfies SchemaForFormData<
  (CreateGMWTask | EditGMWTask)["sourcedocumentData"]["monitoringTubes"][number]["geoOhmCables"]
>;
